'use client';

import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { IndividualMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import type { Dispatch, SetStateAction } from 'react';
import { MentoringCard } from '../../_components/MentoringCard';
import { IndividualMentoringManager } from './IndividualMentoringManager';
import { IndividualPlanBenefits } from './IndividualPlanBenefits';
type IndividualMentoringProps = {
  activeSubscriptionTab: Subscription;
  individualMentoringProduct: IndividualMentoringProductDTO;
  setIndividualMentoringProduct: Dispatch<SetStateAction<IndividualMentoringProductDTO>>;
  goalPage?: boolean;
};
export function IndividualMentoring(t0) {
  const $ = _c(9);
  const {
    activeSubscriptionTab,
    individualMentoringProduct,
    setIndividualMentoringProduct,
    goalPage: t1
  } = t0;
  const goalPage = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IndividualPlanBenefits />;
    t3 = <VerticalSpacer size="content" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== activeSubscriptionTab || $[3] !== individualMentoringProduct || $[4] !== setIndividualMentoringProduct) {
    t4 = <IndividualMentoringManager activeSubscriptionTab={activeSubscriptionTab} individualMentoringProduct={individualMentoringProduct} setIndividualMentoringProduct={setIndividualMentoringProduct} />;
    $[2] = activeSubscriptionTab;
    $[3] = individualMentoringProduct;
    $[4] = setIndividualMentoringProduct;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== goalPage || $[7] !== t4) {
    t5 = <MentoringCard title="Mentoring rozszerzony" details={"Dla os\xF3b, kt\xF3re potrzebuj\u0105 regularnych spotka\u0144 1:1 z mentorem i planu rozwoju u\u0142o\u017Conego indywidualnie pod ich cel, predyspozycje i zainteresowania."} variant="individual" goalPage={goalPage}>{t2}{t3}{t4}</MentoringCard>;
    $[6] = goalPage;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}